GP.GPMod('NavTabBar',function(self) {
    var vent             = self.vent;
    var _util            = self.app.Util;

    var gui = {
        init: function() {

        }
    };

    var apis = {

    };

    var events = {
        init: function() {
            // set current page active state on nav tab footer bar
            vent.on(self.moduleName+":set_active_nav", handlers.set_active_nav, this);
            handlers.set_active_nav();
        },
    };

    var handlers = {

        set_active_nav: function(e) {
            $('#nav-tab-bar-wrap .nav-tab-bar-list li').removeClass('active');
            $('body').removeClass('activity-feed-hide-for-nav');
            $('body').addClass('nav-tab-bar-shown');

            var loc_path = window.location.pathname.split('/');
            var qs_path = window.location.search;
            var cur_page = '';
            if (loc_path.length < 3) {
                // old school url /main.php?a=something.something...
                var qs = qs_path.match(/a=\w+\.(\w+)/i);
                if (qs && qs.length > 1) {
                    cur_page = qs[1];
                }
            } else {
                cur_page =  loc_path[3].toLowerCase();
            }

            switch (cur_page) {
                case 'quicksearch':
                case 'popular':
                case 'browse':
                case 'newfaces':
                case 'viewed':
                    $('#nav-tab-search').addClass('active');
                    $('body').addClass('activity-feed-hide-for-nav');
                    break;
                case 'hotpick':
                    $('#nav-tab-swipe').addClass('active');
                    $('body').addClass('activity-feed-hide-for-nav');
                    break;
                case 'trending':
                    $('#nav-tab-trending').addClass('active');
                    $('body').addClass('activity-feed-hide-for-nav');
                    break;
                case 'live_action':
                    $('#nav-tab-cam').addClass('active');
                    $('body').addClass('activity-feed-hide-for-nav');
                    break;
                case 'add_credits':
                    $('body').removeClass('nav-tab-bar-shown');
                    break;
                default:
            }
        }
    };

    this.addInitializer(function() {
        gui.init();
        events.init();
    });
});

